export default {
    path: '/reportStatistics',
    component: () => import('@/views/layout.vue'),
    redirect: '/reportStatistics',
    name: 'reportStatistics',
    sort: 4,
    icon: 'el-icon-s-data',
    meta: { title: '报表分析' , authCode: ['REPORT001'] },
    children: [
        {
            path: '/deviceReport',
            name: 'DeviceReport',
            component: () => import('@/views/permission/report/deviceReport.vue'),
            meta: {
                title: '设备报表',
                authCode: ['DEV001']
            }
        },
        {
            path: '/personnelReport',
            name: 'PersonnelReport',
            component: () => import('@/views/permission/report/personnelReport.vue'),
            meta: {
                title: '人员报表',
                authCode: ['USER001']
            }
        },
        {
            path: '/dailyCheckReport',
            name: 'DailyCheckReport',
            component: () => import('@/views/permission/report/dailyCheckReport.vue'),
            meta: {
                title: '点检报表',
                authCode: ['DAILY001']
            }
        },
        {
            path: '/planMaintainReport',
            name: 'PlanMaintainReport',
            component: () => import('@/views/permission/report/planMaintainReport.vue'),
            meta: {
                title: '保养报表',
                authCode: ['PLANMAIN001']
            }
        },
        {
            path: '/costReport',
            name: 'CostReport',
            component: () => import('@/views/permission/report/costReport.vue'),
            meta: {
                title: '成本报表',
                authCode: ['COST001']
            }
        },
        {
            path: '/oeeReport',
            name: 'OeeReport',
            component: () => import('@/views/permission/report/oeeReport.vue'),
            meta: {
                title: 'OEE报表',
                 authCode: ['OEE001']
            }
        },
    ]
}
